/**
 * Casts an input field's value to a number type
 */
export const castInputToNumber = (val: unknown): number => {
  const parsedValue = parseFloat(`${val}`);
  if (Number.isNaN(parsedValue)) {
    return 0;
  }
  return parsedValue;
};
